function refreshBlogListing(blogListingContainer, sortOptionId, pageNumber, pageSize) {
  const blogConfigurationId = blogListingContainer.data("id");
  const parentBlogLandingPageId = blogListingContainer.data("pblpid");
  const contextBlogAuthorItemId = blogListingContainer.data("cbaid");
  const contextBlogTagItemId = blogListingContainer.data("cbtaid");
  const contextBlogTopicItemId = blogListingContainer.data("cbtoid");
  if (!sortOptionId) {
    sortOptionId = blogListingContainer.find("[data-type=bloglisting-sortoption].active").data("id");
  }
  if (!pageSize) {
    pageSize = blogListingContainer.find("[data-type=bloglisting-pagesizeoptions]").val();
  }

  const requestData = {
    blogConfigurationId,
    parentBlogLandingPageId,
    contextBlogAuthorItemId,
    contextBlogTagItemId,
    contextBlogTopicItemId,
    sortOptionId,
    pageSize,
    pageNumber
  };
  // $.get("@Url.Action("BlogListingRefresh", "Blog")", requestData)
  $.get("/api/sitecore/Blog/BlogListingRefresh", requestData)
    .done(function(data) {
      // Add the filter/sort settings to the URL
      const url = new URL(window.location);
      if (pageNumber > 0) {
        url.searchParams.set("pn", parseInt(pageNumber) + 1);
      } else {
        url.searchParams.delete("pn");
      }
      const defaultPageSize = blogListingContainer.data("defaultpagesize");
      if (defaultPageSize && pageSize == defaultPageSize) {
        url.searchParams.delete("ps");
      } else {
        url.searchParams.set("ps", pageSize);
      }
      const defaultSortOption = blogListingContainer.data("defaultsortoption");
      if (defaultSortOption && sortOptionId == defaultSortOption) {
        url.searchParams.delete("so");
      } else {
        url.searchParams.set("so", sortOptionId);
      }
      if (window.location.href != url.href) {
        history.pushState({blogConfigurationId, pageNumber, pageSize, sortOptionId}, "", url);
      }

      blogListingContainer.replaceWith(data);
      $([document.documentElement, document.body]).animate({
        scrollTop: $("[data-id=" + blogListingContainer.data("id") + "]").offset().top - 52
      }, 500);
      initBlogListing();
    })
    .fail(function() {
      console.error("Unable to refresh the blog listing with the data: " + JSON.stringify(requestData));
    }
  );
}
function wireUpTopics() {
  $("[data-type=bloglisting-topicnames] span").off().click(function(){
    if($(this).parent().hasClass("open")){
      $(this).parent().removeClass("open");
    }else{
      $(this).parent().addClass("open");
    }
  });

  $(document).on("click", function(e){
    if($(e.target).attr('class') !== "selected-topic"){
      $(".blog-filter").removeClass("open");
    }
  })
}
function wireUpSortOptions() {
  $("[data-type=bloglisting-sortoption]").off().click(function(e) {
    e.preventDefault();
    let blogListingContainer = $(this).closest("[data-type=bloglisting]");
    let sortOptionId = $(this).data("id");
    refreshBlogListing(blogListingContainer, sortOptionId, 0);
  });
}
function wireUpPageSizeOptions() {
  $("[data-type=bloglisting-pagesizeoptions]").off().change(function() {
    let blogListingContainer = $(this).closest("[data-type=bloglisting]");
    refreshBlogListing(blogListingContainer, null, 0);
  });
}
function wireUpPageButtons() {
  $("[data-type=bloglisting-pagebutton]").off().click(function(e) {
    e.preventDefault();
    let blogListingContainer = $(this).closest("[data-type=bloglisting]");
    let pageNumber = $(this).data("pagenumber");
    refreshBlogListing(blogListingContainer, null, pageNumber);
  });
}
function initBlogListing() {
  wireUpTopics();
  wireUpSortOptions();
  wireUpPageSizeOptions();
  wireUpPageButtons();
}
function handlePopstateEvent(e) {
  if (!e || !e.state) return;
  let blogListingContainer = $("[data-id=" + e.state.blogConfigurationId + "]");
  refreshBlogListing(blogListingContainer, e.state.sortOptionId, e.state.pageNumber, e.state.pageSize);
}

$(document).ready(function () {
  initBlogListing();
  addEventListener("popstate", handlePopstateEvent);

  const blogListingContainer = $("[data-type=bloglisting]");
  const defaultPageSize = blogListingContainer.data("defaultpagesize");
  const defaultSortOption = blogListingContainer.data("defaultsortoption");
  history.replaceState({
    blogConfigurationId: blogListingContainer.data("id"),
    pageNumber: 0,
    pageSize: defaultPageSize,
    sortOptionId: defaultSortOption
  }, "");
})
